
export class RegistrationAffiliated {

    federalCode: string;
    courseCode: string;
    name: string;

    constructor() {
        this.federalCode = null;
	this.courseCode = null;
	this.name = null;
    }

}



// WEBPACK FOOTER //
// ./src/models/registrationaffiliated.ts